import React from 'react';
import UnderHeader from '../../../shared/header/under-header';

import TermsContent from './components/terms-content';
import Head from '../../../shared/head';

const TermsOfUse = () => {
    const heroImageContent = (
    <div id="hero-footer" className="hero-footer">
        <div className="row">
        <h1 className="brandon-light">Terms of Use</h1>                        
        </div>
    </div>); 
    return(
        <>
            <Head title={`Loanpal ${window.location.pathname.split('/')[1]}`} />
            <UnderHeader                
                image="img-container-hero-footer-pages"                                
                bgColor="orange-header"
                border=""
                heroImageContent={heroImageContent}
                showDIYSlideshow={false}
                showSlideshowMovie={false}
            />   
            <TermsContent />                                
        </>                
    )
}

export default TermsOfUse;